
module.exports = {
    hasClass(el, className) {
        return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
    },

    addClass(el, className) {
        if (el.classList) el.classList.add(className);
        else if (!this.hasClass(el, className)) el.className += ' ' + className;
    },

    removeClass(el, className) {
        if (el.classList) el.classList.remove(className);
        else el.className = el.className.replace(new RegExp('\\b' + className + '\\b', 'g'), '');
    },

    toggleClass(el, className) {
        if (this.hasClass(el, className)) {
            this.removeClass(el, className);
        } else {
            this.addClass(el, className)
        }
    },

    hide(el) {
        el.style.display = 'none';
    },

    show(el) {
        el.style.display = 'block';
    },

    showFlex(el) {
        el.style.display = 'flex';
    },

    fadeOut(el, timeout = 10) {
        var op = 1;  // initial opacity
        var timer = setInterval(function () {
            if (op <= 0.1) {
                clearInterval(timer);
                el.style.display = 'none';
            }
            el.style.opacity = op;
            el.style.filter = 'alpha(opacity=' + op * 100 + ")";
            op -= op * 0.1;
        }, timeout);
    },

    fadeIn(el, timeout = 10) {
        var op = 0.1;  // initial opacity
        el.style.display = 'block';
        var timer = setInterval(function () {
            if (op >= 1) {
                clearInterval(timer);
            }
            el.style.opacity = op;
            el.style.filter = 'alpha(opacity=' + op * 100 + ")";
            op += op * 0.1;
        }, timeout);
    },

    fadeInFlex(el, timeout = 10) {
        var op = 0.1;  // initial opacity
        el.style.display = 'flex';
        var timer = setInterval(function () {
            if (op >= 1) {
                clearInterval(timer);
            }
            el.style.opacity = op;
            el.style.filter = 'alpha(opacity=' + op * 100 + ")";
            op += op * 0.1;
        }, timeout);
    },

    getClosest(elem, selector) {

        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) { }
                    return i > -1;
                };
        }

        // Get the closest matching element
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector)) return elem;
        }
        return null;

    }
}
